/* import __COLOCATED_TEMPLATE__ from './company-profile-summary-button.hbs'; */
import clsx from 'clsx';
import Component from '@glimmer/component';

const CLASS_NAME = 'company-profile-summary-button';
const ClASS_NAME_HIDDEN = `${CLASS_NAME}--hidden`;

class CompanyProfileSummaryButtonComponent extends Component {
  get disabled() {
    return Boolean(this.args.hidden || this.args.disabled);
  }

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.args.hidden && ClASS_NAME_HIDDEN,
    );
  }
}

export default CompanyProfileSummaryButtonComponent;
